import React, { useEffect } from 'react';
import { SettingsTabsContext } from '../Settings/SettingsTabs';
import Header from 'components/header/Header';
import { General } from './General';
import { LabwareReport } from './LabwareReport';

export const Support = (props) => {
  const { setHeaders } = React.useContext(SettingsTabsContext);

  useEffect(() => {
    if (setHeaders) {
      setHeaders(<Header headerButtons={null} title={'Support'} isNewTheme={true} />);
    }
  }, []);

  return (
    <div id="index-support-wrapper" className="flex flex-col w-[78.5%] h-[73vh]">
      <div
        id="index-support-firstcontainer"
        className="flex flex-row w-[100%] h-[42.5%] mt-[1%]"
      >
        <div id="index-support-firstcontainer-general" className="w-[49.5%] ml-[.5%]">
          <General />
        </div>
        <div id="index-support-firstcontainer-empty" className="w-[49.5%] ml-[.5%]"></div>
      </div>

      <div
        id="index-support-secondcontainer"
        className="flex flex-row w-[100%] h-[54%] mt-[1%]"
      >
        <div
          id="index-support-secondcontainer-labwarereport"
          className="w-[49.5%] ml-[.5%]"
        >
          <LabwareReport />
        </div>
        <div
          id="index-support-secondcontainer-empty"
          className="w-[49.5%] ml-[.5%]"
        ></div>
      </div>
    </div>
  );
};
